import React from 'react';

export const IconWidgets: React.FC = () => (
  <svg
    className="icon-widgets"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" stroke="#15141D" vectorEffect="non-scaling-stroke" />
    <rect x="14" y="3" width="7" height="7" stroke="#15141D" vectorEffect="non-scaling-stroke" />
    <rect x="3" y="14" width="7" height="7" stroke="#15141D" vectorEffect="non-scaling-stroke" />
    <rect x="14" y="14" width="7" height="7" stroke="#15141D" vectorEffect="non-scaling-stroke" />
  </svg>
);
